export const WOD_COMPLETED_REF_ID = 'Work-Order-Detail-Completed';
export const LEASE_CHANGE_OUT_REF_ID = 'Lease-Change-Out';

export const AFFORDABLE_XML_NAMES = [
  'Affordable XML',
  'Affordable State Report',
  'MINC Tenant Transactions',
  'Unit Data Sheet',
];

export const XLSM_REPORT_REFERENCE_IDS = ['CHART-Connect-Report'];

export const XLSX_REPORT_REFERENCE_IDS = ['California-Project-Status-Report'];
